/**
 * Created by DELL on 2017/7/21.
 */
import './style.scss'
import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {KandySession} from '../../containers'
import StateTypes from '../../../constants/StateTypes'

const channelType = StateTypes.app.customers.channelType;

/**
 * CustomerPanel component.
 * Includes a panel to display active customer's information and
 * handle an active session.
 */
class LossPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const {customers, recentCustomers, serviceRequests, selectedCustomer, isWithCall,serviceReqStatus,currentAgent,userCustomer,company,callStats} = this.props
        var customer = ''
        if(serviceRequests&&(serviceRequests.filter(obj => obj._id === selectedCustomer)[0])){
            customer = serviceRequests.filter(obj => obj._id === selectedCustomer)[0]
        }
        if(customers&&(customers.filter(obj => obj._id === selectedCustomer)[0])){
            customer = customers.filter(obj => obj._id === selectedCustomer)[0]
        }
        if(recentCustomers&&(recentCustomers.filter(obj => obj._id === selectedCustomer)[0])){
            customer = customers.filter(obj => obj._id === selectedCustomer)[0]
        }
        if(!customer){
            customer = ''
        }
        var customerPanelDiv

        let isTopPanelImg=true;
        if(customer && customer.isSessionActive){
            isTopPanelImg=false;
        }
        if (!customer) {
            customerPanelDiv = (
                <div className="center-panel">
                    <div className={`center-panel-body ${isTopPanelImg?'center-panel-body-top':''}`}>
                        <img className="workBenchBg"/>
                        <div className="welcome-name">
                            <div className="piccImg"></div>
                            欢迎进入
                            { company ?  company.companyName : "车险理赔平台" }
                        </div>
                    </div>
                </div>
            )
        } else {

                customerPanelDiv = (
                    <KandySession
                        customer={customer}
                        isWithCall={isWithCall}
                        serviceReqStatus={serviceReqStatus}
                        serviceRequests={serviceRequests}
                        userCustomer={userCustomer}
                        callStats={callStats}
                        />
                )
        }
        let top_kandySession = false;
        if (customer && customer.channelType != channelType.wx) {
            top_kandySession = true;
            // var voipContainer = document.getElementById("voip_container")
            //  voipContainer.style.zIndex ="-1";
        }
        return (
            <div className={`${top_kandySession?'top-kandy-session':''}`}>
                {customerPanelDiv}
            </div>
        )
    }
}

/**
 * Props that CustomerPanel component expects to be passed.
 */
LossPanel.propTypes = {
    // Information related to the connected customer.
    selectedCustomer: PropTypes.string,
    customers: PropTypes.array
}

/**
 * Default props when CustomerPanel isn't passed an optional prop.
 */
LossPanel.defaultProps = {
    selectedCustomer: '',
    customers: {}
}

export default LossPanel
